import { routes } from "@/routes/utils";

export const tabs = [
  { title: "Project Info.", value: routes.projectInfo },
  { title: "Category & Sub Category", value: routes.taskCategory },
  { title: "Check for Quality", value: routes.qualityChecklist },
  { title: "Check for Safety", value: routes.safetyChecklist },
  { title: "Team Assignment", value: routes.teamAssignment },
];

export const editTabs = [
  { title: "Project Plan", value: routes.projectPlan },
]
